import React from 'react';
import { useFormat } from 'helpers/hooks/useFormat';
import { AdditionalInfoModal } from '../additional-info-modal';

const Logo = ({
  img,
  description,
}: {
  img?: { className?: string };
  description?: { className?: string; isHidden?: boolean };
}) => {
  const { formatMessage: formatNikonCareMessage } = useFormat({ name: 'nikon-care' });
  const [isModalOpen, setIsModalOpen] = React.useState(false);

  return (
    <>
      <img
        alt="Nikon Care Logo"
        data-testid="nikon-care__logo"
        src="/icons/nikon-care.svg"
        loading="lazy"
        className={img?.className}
      />
      {!description?.isHidden && (
        <>
          <div className="d-flex gap-x-2">
            <p data-testid="nikon-care__description" className={description?.className || 'mb-0'}>
              {formatNikonCareMessage({
                id: 'description',
                defaultMessage: 'Add Extended Care Service Program',
              })}
            </p>
            <img
              data-testid="nikon-care__info"
              src="/icons/tailwind-icons/icon-information.svg"
              loading="lazy"
              className="w-17 cursor-pointer"
              /* #1D3994 to filter CSS auto-generated. */
              style={{
                filter: 'invert(18%) sepia(35%) saturate(4258%) hue-rotate(217deg) brightness(96%) contrast(98%)',
              }}
              onClick={() => setIsModalOpen(true)}
            />
          </div>
          <AdditionalInfoModal show={isModalOpen} onClose={() => setIsModalOpen(false)} />
        </>
      )}
    </>
  );
};

export default Logo;
